import { useInfiniteQuery } from '@tanstack/react-query';
import React, { useCallback, useRef } from 'react'
import { fetchMedias } from '../api/media';
import IsEmpty from './IsEmpty';
import Modal from 'react-responsive-modal';

const MediaSelector = ({openModal, setOpenModal, setPicture, onClick}) => {


    // **1. Fetch All Medias**
    const { 
        data, 
        fetchNextPage, 
        hasNextPage, 
        isFetchingNextPage, 
        status,
    } = useInfiniteQuery({
        queryKey: ["medias"],
        queryFn: fetchMedias,
        getNextPageParam: (lastPage) => lastPage.nextPage,
    });



    const observer = useRef();
    const lastMediaRef = useCallback((node) => {
        if (isFetchingNextPage) return;
        if (!hasNextPage) return;

        if (observer.current) observer.current.disconnect();

        observer.current = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting) {
                fetchNextPage(); 
            }
        });

        if (node) observer.current.observe(node);
    }, [isFetchingNextPage, hasNextPage, fetchNextPage]);
    

    return (
        <Modal open={openModal} onClose={()=>setOpenModal(false)} center classNames={{modal: 'rounded-3 shadow-lg bg-black border',}} closeIcon={<i className="fa fa-times text-white"></i>} focusTrapped={false}>
            <div className='d-flex justify-content-start flex-wrap g-1 mt-4 overflow-y-scroll text-white' style={{maxHeight:"70vh"}}>
                {
                    status === "pending" ? (
                        <div className=' d-flex justify-content-center align-items-center h-100 w-100'>
                            <p className="fs-9s">Chargement des médias...</p>
                        </div>
                    ) : status === "error" ? (
                        <div className=' d-flex justify-content-center align-items-center h-100 w-100'>
                            <p className="fs-9s">Une erreur est survenue.</p>
                        </div>
                    )
                    :data?.pages?.flatMap((page, pageIndex) => 
                        page?.length <= 0 ?
                            <IsEmpty icon={'fa-light fa-image'} message={'Aucune image enregistrée'} />
                        :page.data.map((media, index) => {
                            const isLastItem = pageIndex === data.pages.length - 1 && index === page.data.length - 1;
                            return (
                                <img
                                    key={media.id}
                                    ref={isLastItem ? lastMediaRef : null}
                                    src={media.filePath}
                                    role='button'
                                    alt=''
                                    className='img-fluid object-fit-contain m-1 border bordercolor-primary'
                                    style={{ height: "5rem", width: "auto" }}
                                    onClick={()=>{setPicture(media.filePath); onClick()}}
                                />
                            )
                        })
                    )
                }
                {isFetchingNextPage && <div className=' d-flex justify-content-center align-items-center h-100 w-100'><p className="fs-9s">Chargement...</p></div>}
            </div>
            
        </Modal>
    )
}

export default MediaSelector